export const getToken = () : string => {
    const user = JSON.parse(localStorage.getItem('OSCC') as string);
    return user?.id;
};